export default {
  labels: {
    today: 'I dag',
    pickup_time: 'Afhentningstid',
    on_site_time: 'Serveringstid',
    delivery_time: 'Leveringstid',
  },
};
